// Module
var code = `<div class="cash-amount-picker">
  <ul class="cash-amount-picker-list">
    <li ng-repeat="v in \$ctrl.values">
      <button
        ng-click="selectAmount(v)"
        type="button" class="btn {{isSelected(v) ? \$ctrl.selectedButtonClass : \$ctrl.inactiveButtonClass}}">{{v | nxCurrency}}
      </button>
    </li>

    <li class="li-other">
      <div>
        <div>
          <button
            ng-class="{'selected-other': selectedAmount=='other'}"
            ng-click="clickOther()"
            type="button"
            class="other-button btn {{selectedAmount=='other' ? \$ctrl.selectedButtonClass : \$ctrl.inactiveButtonClass}}">
            other
          </button>
        </div>
        <cash
          ng-show="selectedAmount=='other'"
          ng-model="otherValue"
          ng-change="onChangeOtherField()"
          class="other-input"
          min="0"
          hide-currency="true"></cash>
      </div>
    </li>
  </ul>

  <div class="clearfix"></div>

</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/cash-amount-picker/cash-amount-picker.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;